import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ArchiveVersion } from '../models/ArchiveVersion';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class GraphqlService {
  private _baseUrl: string;
  constructor(
    private http: HttpClient,
    private configurationService : ConfigurationService
  ) {
    this._baseUrl = "";
  }

  getAICPALabels() {
    return this.http.get<any>(this._baseUrl + "/AICPA/GetAICPALabels");
  }

  // getWhatLinksHereContent() {
  //   return this.http.get<any>(this._baseUrl + "/layoutComponents/WhatLinksHereContent");
  // }

  getWhatLinksHereContent(level_One: string, level_Two: string, level_Three: string, level_Four: string, level_Five: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetWhatLinksHere?levelOne=" + level_One + "&levelTwo=" + level_Two + "&levelThree=" + level_Three + "&levelFour=" + level_Four + "&levelFive=" + level_Five);
  }

  getWhatLinksHereLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/WhatLinksHereLabels");
  }
  getothersourceLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/othersourcelabels");
  }
  getPDF(issitess3bucket: boolean, filename: string) {
    return this.http.get(this._baseUrl + "/layoutComponents/getPdf?isSitesBucket=" + issitess3bucket + '&fileName=' + filename, { responseType: 'text' });
  }

  getS3BucketImageGARSLogo() {
    return this.http.get(this._baseUrl + "/LoginPage/GetS3BucketImageGARSLogo", { responseType: 'text' });
  }

  getShowAllPageData(allPagesHeader: any) {
    return this.http.post<any>(this._baseUrl + "/Publications/ShowAllPages?allPagesHeaders", allPagesHeader);
  }

  setCookie(obj) {
    return this.http.get<any>(this._baseUrl + "/LoginPage/SetCookie?value=" + obj);
  }
  getMaintenanceS3Url() {
    return this.http.get(this._baseUrl + "/termsAndConditions/GetS3bucketMaintenanceUrl", { responseType: 'text' });
  }

  DownloadFromS3(filename: string) {
    let url = this._baseUrl + "/layoutComponents/DownloadFromS3?filename=" + filename;
    document.location.href = url;
  }
  getPendingsystemContentFAQlabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/Pendingcontentsystem-FAQ");
  }
  getStandardTypeAcronymslabels() {

    return this.http.get<any>(this._baseUrl + "/crossReference/standardtype-acronyms");
  }
  getCookie() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetCookie");
  }
  getLicenseeLabels() {
    return this.http.get<any>(this._baseUrl + "/Licensee/GetLicenseeLabels");
  }
  getLicenseeYearDropdown() {
    return this.http.get<any>(this._baseUrl + "/Licensee/GetLicenseeYearDropdown");
  }

  getLicenseeReport(selectedYear: any) {
    return this.http.get<any>(this._baseUrl + "/Licensee/GetLicenseeReport?selectedYear=" + selectedYear);
  }
  getSupersededStandardsLabels() {
    return this.http.get<any>(this._baseUrl + "/AICPA/GetSupersededStandardsLabels");
  }

  getLeftMenu(publicationId: string) {
    return this.http.get<any>(this._baseUrl + "/Publications/PublicationWithMap?publicationId=" + publicationId);
  }

  getPageData(publicationId: string, pageId: string, pageNavPath: string, navTitlePath: string, isArchive: boolean) {
    return this.http.get<any>(this._baseUrl + "/Publications/Page?publicationId=" + publicationId + "&pageId=" + pageId + "&pageNavPath=" + pageNavPath + "&navTitlePath=" + navTitlePath + "&isArchive=" + isArchive);
  }

  getFinalPronouncementData() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/finalpronouncement");
  }
  getPronouncementsfromGeneralSites(whatsnewhere: boolean) {
    return this.http.get<any>(this._baseUrl + "/Publications/getPronouncementsfromGeneralSites?whatsnewhere=" + whatsnewhere);
  }
  getpronouncements(GARSArea: string, whatsnewhere: boolean) {
    return this.http.get<any>(this._baseUrl + "/Publications/getPronouncementsandwhatsnew?GARSArea=" + GARSArea +"&whatsnewhere=" + whatsnewhere);
  }


  getWhatsNewData() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/whatsnew");
  }
  getTOClinks() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/TOClinks");
  }
  getTOClabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/getPDFpageLabels");
  }

  getGlobalFooter() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/globalFooter");
  }

  //getLeftNavigation() {
  //  return this.http.get<any>(this._baseUrl + "/layoutComponents/leftNavigation");
  //}
  getCurrentVersionLeftNavigation() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/getCurrentVersionLeftNavigation");
  }
  getArchiveLeftNavigation(publicationId) {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/getArchiveLeftNavigation?publicationId=" + publicationId);
  }

  getLeftNavigationElementstobehidden() {
    return this.http.get(this._baseUrl + "/layoutComponents/GetlisttoHideinLeftNav");
  }

  getAnalyticsTrackingId() {
    return this.http.get(this._baseUrl + "/layoutComponents/getAnalyticsTrackingId", { responseType: 'text' });
  }

  getLinkerList() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/LinkerFile");
  }

  getGlobalLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/navigationLabels");
  }

  getLoginPageContent() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetProfessionViewContent");
  }
  getgeneralFeedbackDropdown() {
    return this.http.get<any>(this._baseUrl + "/Feedback/getgeneralFeedbackDropdown");
  }

  sentmailgeneralFeedback(obj: any) {
    return this.http.post<any>(this._baseUrl + "/Feedback/SentMail", obj);
  }

  getprovideFeedbackDropdown() {
    return this.http.get<any>(this._baseUrl + "/Feedback/getprovideFeedbackDropdown");
  }

  //getUserLogo(){
  //  return this.http.get<any>(this._baseUrl + "/layoutComponents/leftNavUserLogo")
  //}

  //getBookmarkLogo(){
  //  return this.http.get<any>(this._baseUrl + "/layoutComponents/leftNavBookmarkLogo")
  //}

  getTcBasicView() {
    return this.http.get<any>(this._baseUrl + "/termsAndConditions/tcBasicView")
  }

  getTcProfessionalView() {
    return this.http.get<any>(this._baseUrl + "/termsAndConditions/tcProfessionalView")
  }
  getPCPeriodType() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/pcperiodtype")
  }
  getHelpComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpcomponent")
  }
  getHelpAnnotationsComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpAnnotationscomponent")
  }
  getHelpArchivedContentComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpArchivedContentcomponent")
  }
  getHelpBrowsingComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpBrowsingcomponent")
  }
  getHelpBookmarksComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpBookmarkscomponent")
  }
  getHelpGlossaryTermFinderComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpGlossaryTermFindercomponent")
  }
  getHelpJoiningContentComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpJoiningContentcomponent")
  }
  getHelpMyGarsComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpMyGarscomponent")
  }
  getHelpMyHistoryComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpMyHistorycomponent")
  }
  getHelpPrintingComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpPrintingcomponent")
  }
  getHelpRelatedContentComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpRelatedContentcomponent")
  }
  getHelpSearchingComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpSearchingcomponent")
  }
  getHelpSourceTracingComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpSourceTracingcomponent")
  }
  getHelpCopyPasteLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpCopyPastecomponent")
  }
  getHelpContactUsLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpContactUscomponent")
  }
  getHelpShowAllinonepageLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpShowAllcomponent")
  }
  getAboutUsComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/aboutuscomponent")
  }
  getSearchLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/searchcomponent")
  }

  getHomePageLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/HomePageLabels");
  }

  getHomePageComponents() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/HomePageComponent");
  }

  getCopyrightLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/copyrightlabel");
  }

  GetBreadcrumbSession(url: string) {
    if (url.charAt(0).toString() == "/") {
      return this.http.get<any>(this._baseUrl + "/layoutComponents/GetBreadcrumbSession?url=" + url.slice(1));
    }
    else {
      return this.http.get<any>(this._baseUrl + "/layoutComponents/GetBreadcrumbSession?url=" + url);
    }
  }

  GetBreadcrumb(title: string) {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/GetBreadcrumb?title=" + title);
  }

  GetMasterGlossary(term: string, alphabet: string, pageNumber: number, glossaryType: string) {

    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetMasterGlossary?filterTerm=" + term + "&alphabet=" + alphabet + "&pageNumber=" + pageNumber + "&glossaryType=" + glossaryType);
  }

  GetMasterGlossarySearch(term: string, pageNumber: number, glossaryType: string) {

    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetMasterGlossarySearchResult?filterTerm=" + term + "&pageNumber=" + pageNumber + "&glossaryType=" + glossaryType);
  }

  GetMasterGlossarySearchFilter(term: string, pageNumber: number, glossaryType: string, conditionSection: any[], conditionContentType: any[]) {
    let condition = { conditionSection: conditionSection, conditionContentType: conditionContentType };
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetMasterGlossarySearchFilterResult?filterTerm=" + term + "&pageNumber=" + pageNumber + "&glossaryType=" + glossaryType, condition);
  }

  SendContactSupportMail(obj: any) {
    return this.http.post<any>(this._baseUrl + "/LoginPage/SendContactSupportMail", obj);
  }

  getContactSupportLabels() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetContactSupportLabels")
  }
  getS3BucketPath() {
    return this.http.get(this._baseUrl + "/layoutComponents/GetS3BucketPath", { responseType: 'text' });

  }

  SetArchiveVersionSession(archiveVersion: ArchiveVersion) {
    return this.http.post<ArchiveVersion>(this._baseUrl + "/paragraphAction/SetArchiveVersionSession", archiveVersion);
  }

  GetArchiveVersionSession() {
    return this.http.get<ArchiveVersion>(this._baseUrl + "/paragraphAction/GetArchiveVersionSession")
  }

  GetArchiveLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/ArchiveLabels")
  }

  getSourceTracingToolLabel() {
    return this.http.get<any>(this._baseUrl + "/sourceTracingTool/sourcetracingtoollabel");
  }
  getEffectivedateComponentLabels() {

    return this.http.get<any>(this._baseUrl + "/Publications/GetEffectivedateContent");

  }
  getEffectivedateComponentHeaderLabels() {

    return this.http.get<any>(this._baseUrl + "/Publications/effectivedates");

  }

  GetGlossarySearch(searchTerm: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetGlossarySearch?searchTerm=" + searchTerm);
  }

  getAutoSuggestionsElasticSearch(searchTerm: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetAutoSuggestions?searchTerm=" + searchTerm);
  }
  getRelatedContentComponentLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/Realtedcontent");
  }

  getTop5CodElasticSearch(searchTerm: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/Top5Cod?searchTerm=" + searchTerm);
  }

  getCodElasticSearch(elasticSearchCondition, pageNumber: number) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetCodElasticSearch?pageNumber=" + pageNumber, elasticSearchCondition);
  }

  getTop5OpElasticSearch(searchTerm: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/Top5Op?searchTerm=" + searchTerm);
  }

  getOpElasticSearch(elasticSearchCondition, pageNumber: number) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetOpElasticSearch?pageNumber=" + pageNumber, elasticSearchCondition);
  }

  getTop5CigElasticSearch(searchTerm: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/Top5Cig?searchTerm=" + searchTerm);
  }

  getCigElasticSearch(elasticSearchCondition, pageNumber: number) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetCigElasticSearch?pageNumber=" + pageNumber, elasticSearchCondition);
  }

  generateReportForStandardForm(pronouncementType, number, paragraphQuestionOrFootnote) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/generateReportForStandardForm?pronouncementType=" + pronouncementType + "&number=" + number + "&paragraphQuestionOrFootnote=" + paragraphQuestionOrFootnote);
  }

  generateReportForCodificationForm(section, paragraphQuestionOrFootnote) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/generateReportForCodificationForm?section=" + section + "&paragraphQuestionOrFootnote=" + paragraphQuestionOrFootnote);
  }

  generateReportForCIGForm(chapter, paragraphQuestionFootnoteAppendixAndGlossaryTerm) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/generateReportForCIGForm?chapter=" + chapter + "&paragraphQuestionFootnoteAppendixAndGlossaryTerm=" + paragraphQuestionFootnoteAppendixAndGlossaryTerm);
  }

  getSourceTracingToolDropdown() {
    return this.http.get<any>(this._baseUrl + "/sourceTracingTool/sourcetracingtoolDropdown");
  }

  getGlossaryAlphabetList() {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetMasterGlossaryAlphabetsList");
  }
  GetMasterGLossaryAlphabetsfiltered(filter: any) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetMasterGLossaryAlphabetsfiltered?filteredterm=" + filter);
  }

  getS3BucketImagePath() {
    return this.http.get(this._baseUrl + "/LayoutComponents/GetS3BucketImagePath", { responseType: 'text' });
  }

  getESSourceTracingToolDropdown(Collection: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetSourceTracingToolDropDownValues?Collection=" + Collection);
  }

  getSourceTracingToolReport(InputData) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetSourceTracingToolReport", InputData);
  }

  getInlineGlossaryContent(glossaryId: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetInlineGlossary?glossaryTermId=" + glossaryId);
  }

  //getNavPathTree(path: string) {
  //  return this.http.get<any>(this._baseUrl + "/layoutComponents/getNavPathTree?path=" + path);
  //}
  getAcroynmLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/getAcroynmLabels")
  }

  getCIGParamValue() {
    return this.http.get(this._baseUrl + "/sourceTracingTool/getCIGParamValue", { responseType: 'text' });
  }

  getCryptionKeys() {
    return this.http.get(this._baseUrl + "/layoutComponents/getCryptionkeys", { responseType: 'text' });
  }

  getAnalyticsStatus() {
    return this.http.get(this._baseUrl + "/layoutComponents/getAnalyticsStatus", { responseType: 'text' });
  }
  getArchiveLandingPageComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/getArchiveLandingPageComponentLabel")
  }

  getRedisCacheLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/getRedisCacheLabels");
  }

  clearRedisCache(application: string, environment: string, siteURL: string) {
    return this.http.get(this._baseUrl + "/layoutComponents/clearRedisCache?application=" + application + "&environment=" + environment + "&siteURL=" + siteURL, { responseType: 'text' });
  }

  getCurrentVersionName() {
    return this.http.get(this._baseUrl + "/layoutComponents/getCurrentVersionName", { responseType: 'text' });
  }

  getPDFBackupLandingPageLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/getPDFBackupLandingPageLabels");
  }

  GetPDFBackupPageListAsync(versionPubId: any) {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/GetPDFBackupPageList?publicationId=" + versionPubId);
  }
  GetPDFBackupPageListForProViewAsync(versionPubId: any) {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/GetPDFBackupPageListForProView?publicationId=" + versionPubId);
  }
  getSiteKey() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/getSiteKey");
  }
}
